import { render, staticRenderFns } from "./OptionalColorModuleFilters.vue?vue&type=template&id=59218828&scoped=true"
import script from "./OptionalColorModuleFilters.vue?vue&type=script&lang=ts"
export * from "./OptionalColorModuleFilters.vue?vue&type=script&lang=ts"
import style0 from "./OptionalColorModuleFilters.vue?vue&type=style&index=0&id=59218828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59218828",
  null
  
)

export default component.exports